import { ReactNode } from 'react'

interface CTACardProps {
  children: ReactNode
  className?: string
}

/**
 * Consistent CTA card styling used across marketing pages
 */
export function CTACard({ children, className = '' }: CTACardProps) {
  return (
    <div
      className={`group relative rounded-2xl border border-white/20 bg-white/10 p-8 shadow-lg backdrop-blur-xl transition-all duration-300 hover:border-white/25 hover:shadow-xl md:p-10 ${className}`}
    >
      <div className="relative z-10">{children}</div>
    </div>
  )
}
